import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SectionText } from '@fortress-technology-solutions/fortress-component-library/Molecules_Portal';

const AffordaResultsEligible = () => {
  return (
    <SectionText
      title={<FormattedMessage id="afforda.resultsElegible.title" />}
      description={
        <FormattedMessage id="afforda.resultsElegible.description" />
      }
      secondaryDescription={
        <FormattedMessage id="afforda.resultsElegible.secondaryDescription" />
      }
      sx={{
        paddingY: 2,
      }}
    />
  );
};

export default AffordaResultsEligible;
